var gnav = {cnst:{}},//Global namespace for JS functions
		App = window.App || {omninav:{footer:{}}},// set App for some legacy pages that are dependent on this obj.
		gnavOptions = window.gnavOptions || {};// options for customization by other teams. Found in head of pages that have it defined.
		gnavOptions.variation = gnavOptions.variation || window.gnav_limited_variation;// legacy var "gnav_limited_variation" added here to gnavOptions
		gnavOptions.legacy984 = gnavOptions.legacy984 || window.bau984;// legacy var "bau984" added here to gnavOptions

gnav.wlc = window.location.pathname;
gnav.biz = (gnav.wlc.indexOf('content/wcms/one-digital/home/business') === 1 || 
						gnav.wlc.indexOf('homepage/business') === 1 || 
						gnav.wlc.indexOf('business') === 1 || 
						gnav.wlc.indexOf('biz') === 1 || 
						gnav.wlc.indexOf('articles/business/') === 1 || 
						gnav.wlc.indexOf('/businesssolutions/') !== -1)
						
// Site id for idenfifying JSON location
// Main flag for AGENT SITE specific changes and header/footer JSON
if(window.isAgentSite) {
    gnav.isAgentSite = window.isAgentSite;
    gnav.agentSiteId = window.siteId;
}

gnav.find = (arrayOfStringsToFind, searchString) => {
	for(var i=0;i<arrayOfStringsToFind.length;i++){
		if(searchString.indexOf(arrayOfStringsToFind[i]) !== -1){
			return searchString.indexOf(arrayOfStringsToFind[i])
		}
	}
	return null;
}

gnav.acctNumFix = (acctNum) => {
	while(acctNum.indexOf('0') == '0'){
		acctNum = acctNum.substr(1)
	}
	if(acctNum.indexOf('-')<0){
		var str1 = acctNum.substr(0,acctNum.length-5)
		var str2 = acctNum.substr(-5)
		acctNum = str1+'-'+str2
	}
	acctNum = 'XXXXX'+acctNum.substr(5)
	return acctNum;
}

/*
calling sessionStorage causes errors when cookies are disabled
if(!window.sessionStorage){
	var sessionStorage = {},
			localStorage = {};
}
*/
gnav.setConstants = function(){
	var footerFolder = 'global-footer/',
			footerFile = '.globalfooter.json',
			headerFolder = 'global-header/',
			headerFile = '.globalheader.json',
			headerOrigin = 'https://scache2.vzw.com',
			footerOrigin = 'https://scache1.vzw.com',
			filePath = '/ui-one-digital/',
			specialFolder = '',
			prospect = 'prospect',
			customer = 'customer',
			business = 'business',
			service = 'service',
			privacy = 'privacy',
			host = window.location.host,
			hostRay = host.split('.'),
			href = encodeURI(location.href),
			preProdRay = ['testman','preprodwbillpay','preprodnbillpay','preprodbillpaysvc','presupport','ppmyvpostpay','tlogin','mediastore-pf2','prevzwworkshops','tmyacct','community-stage'],
			prodTestRay = ['ecommstage'];				

	if ((hostRay.length === 3 && hostRay[0].indexOf('qa')!==-1) || !host.indexOf('local')) {
		// This is local
		if(!host.indexOf('local')){
			gnav.cnst.runningLocalEnv = true;
			gnav.cnst.APP_DOMAIN = '';	
			gnav.cnst.APP_HOST = 'vzwqa1';
			gnav.cnst.MYV_HOST = 'qa1billpay';
			
			/* comment following 3 lines to get latest json from prod */
			headerOrigin = '';
			footerOrigin = '';
			filePath = '/content/wcms/one-digital/'; // temporarily moved to 'local' condition for CORS policy testing
			
		}
		// This is lower env
		else{
			gnav.cnst.runningLowerEnv = true;
			var envNum = parseInt(hostRay[0].substr(hostRay[0].indexOf('qa')+2));
			gnav.cnst.APP_DOMAIN = 'https://vzwqa'+ envNum +'.verizonwireless.com';
			gnav.cnst.SEARCH_DOMAIN = gnav.cnst.APP_DOMAIN;
			gnav.cnst.APP_HOST = 'vzwqa'+ envNum;
			gnav.cnst.MYV_HOST = 'qa'+ envNum +'billpay';
			gnav.cnst.AM_HOST = 'accessmgrqa'+ envNum;
			
			
			/* 1) lower env take json from lower env DEPRECATED! 
			headerOrigin = gnav.cnst.APP_DOMAIN;
			footerOrigin = gnav.cnst.APP_DOMAIN;
			filePath = '/content/wcms/one-digital/';
			*/
			
			/* 2) lower env take json that is authored in lower env then copied to lower env folder on stcache */
			specialFolder = 'qa'+ envNum +'/';
			headerOrigin = 'https://stcache.vzw.com';
			footerOrigin = 'https://stcache.vzw.com';
			
			 
			/* 3) lower env take json from same stcache location authored on testman
			headerOrigin = 'https://stcache.vzw.com';
			footerOrigin = 'https://stcache.vzw.com';			 
			*/
		}

	  gnav.cnst.SIGNOUT_URL = gnavOptions.signOutUrl || "https://"+ gnav.cnst.AM_HOST + ".verizonwireless.com/clp/login?redirect=/myv/nda/amLogoutRedirect.jsp&next=" + href;
	  
	  if(window.gnavJsonPath){
	  	filePath = window.gnavJsonPath;
	  }
	} 
	// this is PreProd
	else if (gnav.find(preProdRay, hostRay[0]) === 0)  {
	  gnav.cnst.runningFromPreProd = true;
	  headerOrigin = 'https://stcache.vzw.com';
		footerOrigin = 'https://stcache.vzw.com';
		//specialFolder = 'testman/';
		gnav.cnst.APP_HOST = 'testman';
		gnav.cnst.MYV_HOST = 'ppmyvpostpay';
		gnav.cnst.AM_HOST = 'tlogin',
	  gnav.cnst.SIGNOUT_URL = gnavOptions.signOutUrl || "https://tlogin.verizonwireless.com/vzauth/UI/Logout?next=" + href;
	  gnav.cnst.APP_DOMAIN = 'https://testman.verizonwireless.com';
	  gnav.cnst.SEARCH_DOMAIN = 'https://search-test.verizonwireless.com';
	} 
	// This is AEM configured Prod Test env
	else if (gnav.find(prodTestRay, hostRay[0]) === 0)  {
	  headerOrigin = 'https://stcache.vzw.com';
		footerOrigin = 'https://stcache.vzw.com';
		specialFolder = hostRay[0]+'/';
	  gnav.cnst.runningFromProdTest = true;
		gnav.cnst.APP_HOST = hostRay[0];
		gnav.cnst.MYV_HOST = 'myvpostpay';
		gnav.cnst.AM_HOST = 'login',
	  gnav.cnst.SIGNOUT_URL = gnavOptions.signOutUrl || "https://login.verizonwireless.com/vzauth/UI/Logout?next=" + href;
	  gnav.cnst.APP_DOMAIN = 'https://'+ hostRay[0] +'.verizonwireless.com';
	  gnav.cnst.SEARCH_DOMAIN = 'https://search.verizonwireless.com';
	}
	// this is PROD or prod-test env
	else {
		gnav.cnst.APP_HOST = hostRay[0];
		gnav.cnst.runningFromProd = true;
		gnav.cnst.SIGNOUT_URL = gnavOptions.signOutUrl || "https://login.verizonwireless.com/vzauth/UI/Logout?next=" + href;
		gnav.cnst.APP_DOMAIN = 'https://www.verizonwireless.com';
		gnav.cnst.SEARCH_DOMAIN = 'https://search.verizonwireless.com';
	}	
	gnav.cnst.HEADER_JSON_URL_BIZ = headerOrigin+filePath+headerFolder+specialFolder+business+headerFile;
	gnav.cnst.FOOTER_JSON_URL_BIZ = footerOrigin+filePath+footerFolder+specialFolder+business+footerFile;
	gnav.cnst.HEADER_JSON_URL_CUSTOMER = headerOrigin+filePath+headerFolder+specialFolder+customer+headerFile;
	gnav.cnst.FOOTER_JSON_URL_CUSTOMER = footerOrigin+filePath+footerFolder+specialFolder+customer+footerFile;
	gnav.cnst.HEADER_JSON_URL_PROSPECT = headerOrigin+filePath+headerFolder+specialFolder+prospect+headerFile;
	gnav.cnst.FOOTER_JSON_URL_PROSPECT = footerOrigin+filePath+footerFolder+specialFolder+prospect+footerFile;
	gnav.cnst.HEADER_JSON_URL_SERVICE = headerOrigin+filePath+headerFolder+specialFolder+service+headerFile;
	gnav.cnst.FOOTER_JSON_URL_SERVICE = footerOrigin+filePath+footerFolder+specialFolder+service+footerFile;
	gnav.cnst.HEADER_JSON_URL_PRIVACY = headerOrigin+filePath+headerFolder+specialFolder+privacy+headerFile;
	gnav.cnst.FOOTER_JSON_URL_PRIVACY = footerOrigin+filePath+footerFolder+specialFolder+privacy+footerFile;
	
	gnav.cnst.DOMAIN = hostRay[1]
	
	// sessionStorage.gnavCnst = JSON.stringify(gnav.cnst)
}

gnav.setAgentSiteConstants = function() {
	var footerFolder = 'global-footer/' + gnav.agentSiteId + '/',
    footerFile = '.globalfooter.json',
    headerFolder = 'global-header/' + gnav.agentSiteId + '/',
    headerFile = '.globalheader.json',
    headerOrigin = 'https://scache2.vzw.com',
    footerOrigin = 'https://scache1.vzw.com',
    filePath = '/ui-one-digital/',
    prospect = 'prospect', 
    customer = 'customer',
    business = 'business',
    service = 'service',
    host = window.location.host,
    hostSplit = host.split('.'),
    hostSubDomain = hostSplit[0],
    qaDevHostNames = ['qa2wcs'],
    bizDevHostNames = ['rc', 'gw', 'cs', 'aw', 'testshop'],
    bizDevMainDomain = ['verizonwireless', 'victra'];
    gnav.cnst.SIGNOUT_URL = '/od/cust/auth/logout';
  
    if ((hostSplit.length === 3 && (hostSubDomain.indexOf('-qa') !== -1  || qaDevHostNames.indexOf(hostSubDomain) > -1 )) || !host.indexOf('local')) {
      headerOrigin = '';
      footerOrigin = '';
      if(!host.indexOf('local')) {
        filePath = '/content/wcms/one-digital/';
      }
      gnav.cnst.runningLowerEnv = true;
    } 
    else if (bizDevHostNames.indexOf(hostSubDomain) > -1 && bizDevMainDomain.indexOf(hostSplit[1]) > -1) {
      headerOrigin = 'https://stcache.vzw.com';
      footerOrigin = 'https://stcache.vzw.com';
      gnav.cnst.runningFromPreProd = true;
    } 
    else {
      gnav.cnst.runningFromProd = true;
    }
    // Allow overwrite JSON domain, path for bizdev and qa sites
    if(gnav.cnst.runningLowerEnv || gnav.cnst.runningFromPreProd) {
      if(window.gnavJsonDomain && typeof(window.gnavJsonDomain) === "string") {
        headerOrigin = window.gnavJsonDomain;
        footerOrigin = window.gnavJsonDomain;
      }
      if(window.gnavJsonPath) {
        filePath = window.gnavJsonPath;
      }
    }
		gnav.cnst.APP_DOMAIN = 'https://www.verizonwireless.com';
		gnav.cnst.SEARCH_DOMAIN = 'https://search.verizonwireless.com';
    gnav.cnst.HEADER_JSON_URL_BIZ = headerOrigin+filePath+headerFolder+business+headerFile;
    gnav.cnst.FOOTER_JSON_URL_BIZ = footerOrigin+filePath+footerFolder+business+footerFile;
    gnav.cnst.HEADER_JSON_URL_CUSTOMER = headerOrigin+filePath+headerFolder+customer+headerFile;
    gnav.cnst.FOOTER_JSON_URL_CUSTOMER = footerOrigin+filePath+footerFolder+customer+footerFile;
    gnav.cnst.HEADER_JSON_URL_PROSPECT = headerOrigin+filePath+headerFolder+prospect+headerFile;
    gnav.cnst.FOOTER_JSON_URL_PROSPECT = footerOrigin+filePath+footerFolder+prospect+footerFile;
    gnav.cnst.HEADER_JSON_URL_SERVICE = headerOrigin+filePath+headerFolder+service+headerFile;
		gnav.cnst.FOOTER_JSON_URL_SERVICE = footerOrigin+filePath+footerFolder+service+footerFile;
    
    // sessionStorage.gnavCnst = JSON.stringify(gnav.cnst);
}

// store constants in sessionStorage to avoid calling methods
/*
calling sessionStorage causes errors when cookies are disabled
if(sessionStorage.gnavCnst){
	gnav.cnst = JSON.parse(sessionStorage.gnavCnst);
}else 
*/
if(gnav.agentSiteId) {
  gnav.setAgentSiteConstants();
} else {
  gnav.setConstants();
}


/** All the helpers functions here **/
gnav.mobilecheck = () => {
  var check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

gnav.makeAjaxCall = (url, methodType, data, withCreds) => {
  var promiseObj = new ES6Promise((resolve, reject) => {	
    var xhr = new XMLHttpRequest();
    xhr.open(methodType, url, true);
    if (withCreds) {
    	xhr.withCredentials=true;
    }
    if (data && data.headers) {
      var headers = data.headers;
      headers.map((data) => {    	
        xhr.setRequestHeader(data.name, data.value);
      });
    }
    if (data && data.postData) {
      var ajaxData = data.postData;
    } else {
      var ajaxData = data;
    }
    xhr.send(ajaxData);
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          // console.log("xhr done successfully");
          var resp = xhr.responseText;
          if (resp) {
            try {
              var respJson = JSON.parse(resp);
              resolve(respJson);
            } catch (e) {
              resolve(resp);
            }
          } else {
            reject(xhr.status)
          }
        } else {
          reject(xhr.status);
          // console.log("xhr failed");
        }
      } else {
        // console.log("xhr processing going on");
      }
    };
    // console.log("request sent succesfully");
  });
  return promiseObj;
};
gnav.makeSearchCall = (url, methodType, headers, postData) => {
  var promiseObj = new ES6Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.open(methodType, url, true);
    headers.map((data) => {
      xhr.setRequestHeader(data.name, data.value);
    });
    xhr.send(postData);
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          // console.log("xhr done successfully");
          var resp = xhr.responseText;
          var respJson = JSON.parse(resp);
          resolve(respJson);
        } else {
          reject(xhr.status);
          // console.log("xhr failed");
        }
      } else {
        // console.log("xhr processing going on");
      }
    };
    // console.log("request sent succesfully");
  });
  return promiseObj;
};
/** validate cookie value for Fortify Security Scan.
 * requires a custom rule in Fortify (Cleanse Rule) 
 * that trusts in the result value of "validateCookieVal"
 * @param {String} value
 * * */
gnav.validateCookieVal = (value) => {
	//console.log('test',/^[a-zA-Z0-9 %_/\|\+]*$/.test(value), !/%0/.test(value))
	if(/^[a-zA-Z0-9 %_/\|\+]*$/.test(value) && !/%0/.test(value)){ 
		return value;
	}else{
		console.log('illegal cookie value in the globalnav: "'+value+'"');
		return null;
	}
}
/** createCookie will create a cookie  * 
 * @param {String} name
 * @param {String} value
 * @param {Number} days
 * **/
gnav.createCookie = (name, value, days) => {
	//console.log('gnav.createCookie',name)
	if(gnav.validateCookieVal(value)===null) return;
	var domain = gnav.cnst.runningLocalEnv ? "localhost" : location.host.split('.')[1]+".com";
	var secure = location.protocol === 'https:' ? ';secure' : '';
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + gnav.validateCookieVal(value) + expires + ";domain="+domain+";path=/"+secure;
};

// Delete cookie with the value function 
gnav.eraseCookie = (name) => {
  if(typeof name === "string") {
    gnav.createCookie(name, "", -1);
  } else {
    for(var i=0;i < name.length;i++) {
      if(gnav.getCookie(name[i])) {
        gnav.createCookie(name[i], "", -1);
      }
    }
  }
};

// Get cookie function
gnav.getCookie = (c_name) => {
  var c_value = " " + document.cookie;
  var c_start = c_value.indexOf(" " + c_name + "=");
  if (c_start == -1) {
    c_value = null;
  }
  else {
    c_start = c_value.indexOf("=", c_start) + 1;
    var c_end = c_value.indexOf(";", c_start);
    if (c_end == -1) {
      c_end = c_value.length;
    }
    c_value = unescape(c_value.substring(c_start, c_end));
  }
  return c_value;
};

// Set a interval for executing a function
gnav.debounce = (func, wait, immediate) => {
  var timeout;
  return function () {
    var context = this, args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

// find dom element using querySelector 
gnav.dom = (selector) => {
  return document.querySelector(selector);
};

// Cart functionality

// gnav.createCookie("vsi", "vsi");
// gnav.createCookie("persistCart", "persistCart");
// gnav.createCookie("removePerCart", "removePerCart");

gnav.calculateCartDifference = (cartDate, currentDate) => {
  var _MS_PER_DAY = 1000 * 60 * 60 * 24;
  var utc1 = Date.UTC(cartDate.getFullYear(), cartDate.getMonth(), cartDate.getDate());
  var utc2 = Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
};
gnav.createStorageFromCart = () => {
  var creationDate = new Date();
  // Set the cartItemsJSON if cartItemsJSON is in window Object
  if (window.cartItemsJSON && window.cartItemsJSON.commerceJSON) {
    localStorage.setItem("commerceJSON", cartItemsJSON.commerceJSON);
    localStorage.setItem("commerceJSONDate", creationDate);
  }

};
gnav.paramVal = (key) => {
  var params = window.location.search + '&'
  if (params.indexOf(key) === -1) {
    return null
  } else {
    var val = params.substr(params.indexOf(key))
    val = val.substring(val.indexOf('=') + 1, val.indexOf('&'))
    return val
  }
}
gnav.initGoogleSearch = () => {
  gnav.googleSearchInitialized = true;
  var input = document.getElementById('googleSearchInput');
  var infowindow = new google.maps.InfoWindow();
  var infowindowContent = document.getElementById('googleSearchContent');
  gnav.autocomplete = new google.maps.places.Autocomplete(input);
  gnav.autocomplete.setComponentRestrictions({ 'country': ['us'] });
  gnav.autocomplete.setTypes(['geocode'])
  gnav.autocomplete.addListener('place_changed', function () {
    var place = gnav.autocomplete.getPlace();
    if (!place.geometry) {
    /*
			if (place.name.length === 5 && parseInt(place.name) / parseInt(place.name) === 1) {
	      location.href = gnav.cnst.APP_DOMAIN + "/stores/interstetialpage/?q=" + place.name
	    }
	  */
      return;
    }
		if (navigator.userAgent.search("Firefox") >= 0) {    
			var sourceUrl= window.location.href;
			history.pushState({}, '', sourceUrl);
		}
    var lat = place.geometry.location.lat() ? place.geometry.location.lat().toFixed(6) : '';
    var lng = place.geometry.location.lng() ? place.geometry.location.lng().toFixed(6) : '';
    location.href = gnav.cnst.APP_DOMAIN + "/stores/storesearchresults/?allow=1&lat=" + lat + "&long=" + lng + "&result=all&q=" + encodeURI(place.formatted_address);
  });
  //console.log('gnav.initGoogleSearch called')
}
gnav.loadGoogleScript = () => {
  if (!window.google || !window.google.maps) {
    var channel = gnav.mobilecheck() ? 'mobile' : 'desktop';
    var gglScript = document.createElement('script');
    gglScript.type = 'text/javascript';
    gglScript.rel = 'stylesheet';
    gglScript.async = 'true';
    gglScript.src = 'https://maps.googleapis.com/maps/api/js?client=gme-verizonwireless2&channel=vzw-' + channel + '&libraries=places&callback=gnav.initGoogleSearch';
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(gglScript);
    //console.log('loaded googlemaps script')
  } else if (!gnav.googleSearchInitialized) {
    gnav.initGoogleSearch()
  }
}
gnav.scrollToBottom = () => {
  var scrollHeight = document.body.scrollHeight;
  var windowHeight = window.innerHeight;
  var currentScroll = window.pageYOffset || document.documentElement.scrollTop;
  var scrollDistance = scrollHeight - windowHeight;
  if (currentScroll < scrollDistance) {
    window.scrollTo(0, currentScroll + 10);
    setTimeout(gnav.scrollToBottom, 0)
  }
}

//method to create accessible dom element click
gnav.accessibleClickEnter = (fn) => ({
    onClick: fn,
    onKeyDown: (e) => {
        if(e.which===13 || e.which===32) {
            // Prevent the default action to stop scrolling when space is pressed
            e.preventDefault();
            return fn(e);
        }
    },
    tabIndex: "0",
});

gnav.updateCartCountCookie = (cartVal) => {
  //console.log('--updateCartCountCookie',cartVal)
  try{
    var cartCookie = gnav.getCookie('isPrepayCartExist') 
    		? 'prepayCartCount'
    		: gnav.getCookie('loggedIn')
    		? 'gnCartCount'
    		:'prospectCartCount';
    cartVal = parseInt(cartVal);
    if(cartVal>=0){
    	//console.log('cartval >= 0')
        if(cartVal===0){
        	//console.log('cartVal===0')
        gnav.eraseCookie(cartCookie);
        gnav.dom('#navCartCircle').style.display='none';
        gnav.dom('#navCartCount').innerHTML = '';
        }else{
        	//console.log('cartVal!==0')
        gnav.createCookie(cartCookie,cartVal);
        gnav.dom('#navCartCount').innerHTML = cartVal;
        gnav.dom('#navCartCircle').style.display='';
       }
    }
    }catch(err){}

}
/** helpers functions ENDS here **/

// Version: '1.0.23' motionpoint start (needed for Spanish/English toggle)
var MP = {
    //<!-- mp_trans_disable_start -->
    Version: "1.0.23",
    Domains: {"es": "es.verizonwireless.com"},
    SrcLang: "en",
    //<!-- mp_trans_disable_end -->
    UrlLang: "mp_js_current_lang",
    SrcUrl: decodeURIComponent("mp_js_orgin_url"),
    //<!-- mp_trans_disable_start -->
    init: function () {
        if (MP.UrlLang.indexOf("p_js_") == 1) {
            MP.SrcUrl = location.href;
            MP.UrlLang = MP.SrcLang;
        }
    },
    getCookie: function (name) {
        var start = document.cookie.indexOf(name + "=");
        if (start < 0) return null;
        start = start + name.length + 1;
        var end = document.cookie.indexOf(";", start);
        if (end < 0) end = document.cookie.length;
        while (document.cookie.charAt(start) == " ") {
            start++;
        }
        return decodeURIComponent(document.cookie.substring(start, end));
    },
    setCookie: function (name, value, path, domain) {
        var cookie = name + "=" + encodeURIComponent(value);
        if (path) cookie += "; path=" + path;
        if (domain) cookie += "; domain=" + domain;
        var now = new Date();
        now.setTime(now.getTime() + 1000 * 60 * 60 * 24 * 365);
        cookie += "; expires=" + now.toUTCString();
        document.cookie = cookie;
    },
    switchLanguage: function (lang) {
        if (lang != MP.SrcLang) {
            var script = document.createElement("SCRIPT");
            script.src = location.protocol + "//" + MP.Domains[lang] + "/" + MP.SrcLang + lang + "/?1023749632;" + encodeURIComponent(MP.SrcUrl);
            document.body.appendChild(script);
        } else if (lang == MP.SrcLang && MP.UrlLang != MP.SrcLang) {
            var script = document.createElement("SCRIPT");
            script.src = location.protocol + "//" + MP.Domains[MP.UrlLang] + "/" + MP.SrcLang + MP.UrlLang + "/?1023749634;" + encodeURIComponent(location.href);
            document.body.appendChild(script);
        }
        return false;
    },
    switchToLang: function (url) {
        location.href = url;
    }
    //<!-- mp_trans_disable_end -->
};






// polifill for IE
(function () {
    if ( typeof NodeList.prototype.forEach === "function" ) return false;
    NodeList.prototype.forEach = Array.prototype.forEach;
})();

//Dummy search data for local testing of predictive search
/*
var dummySearchData = {
  "originalTerms": [
    "apple*"
  ],
  "products": {
    "devices": [
      {
        "isPrepaid": "true",
        "img_url": "http://s7.vzw.com/is/image/VerizonWireless/iphone6s-plus-spgry-front",
        "price": "949.99",
        "name": "iPhone&reg; 6s Plus Prepaid",
        "img_alt": "iPhone&reg; 6s Plus Prepaid",
        "url": "http://www.verizonwireless.com/prepaid/smartphone-plans/apple-iphone-6s-plus-128gb-in-gold+prepaid",
        "desc": "iPhone&reg; 6s Plus Prepaid"
      },
      {
        "rate": "4.8333",
        "reviewCount": "6",
        "img_url": "http://s7.vzw.com/is/image/VerizonWireless/apple-ipad-mini4-spgry-front",
        "price": "22.08",
        "name": "iPad&reg; mini 4",
        "isEdgePrice": "true",
        "img_alt": "iPad&reg; mini 4",
        "url": "http://www.verizonwireless.com/tablets/apple-ipad-mini-4",
        "desc": "iPad&reg; mini 4"
      },
      {
        "rate": "4.3688",
        "reviewCount": "18325",
        "img_url": "http://s7.vzw.com/is/image/VerizonWireless/apple-iphone-6-spacegray",
        "price": "22.91",
        "name": "iPhone&reg; 6",
        "isEdgePrice": "true",
        "img_alt": "iPhone&reg; 6",
        "isTwoYearPriceRestriction": "true",
        "url": "http://www.verizonwireless.com/smartphones/iphone-6",
        "desc": "iPhone&reg; 6"
      },
      {
        "rate": "4.4573",
        "reviewCount": "446",
        "img_url": "http://s7.vzw.com/is/image/VerizonWireless/apple_iPhoneSE_SpGry",
        "price": "16.66",
        "name": "iPhone&reg; SE",
        "isEdgePrice": "true",
        "img_alt": "iPhone&reg; SE",
        "isTwoYearPriceRestriction": "true",
        "url": "http://www.verizonwireless.com/smartphones/apple-iphone-se",
        "desc": "iPhone&reg; SE"
      },
      {
        "isPrepaid": "true",
        "img_url": "http://s7.vzw.com/is/image/VerizonWireless/apple_iPhoneSE_SpGry",
        "price": "399.99",
        "name": "iPhone&reg; SE Prepaid",
        "img_alt": "iPhone&reg; SE Prepaid",
        "url": "http://www.verizonwireless.com/prepaid/smartphone-plans/apple-iphone-se-16b-in-silver+prepaid",
        "desc": "iPhone&reg; SE Prepaid"
      },
      {
        "rate": "4.544",
        "reviewCount": "3349",
        "img_url": "http://s7.vzw.com/is/image/VerizonWireless/iphone6s-plus-spgry-front",
        "price": "31.24",
        "name": "iPhone&reg; 6s Plus",
        "isEdgePrice": "true",
        "img_alt": "iPhone&reg; 6s Plus",
        "isTwoYearPriceRestriction": "true",
        "url": "http://www.verizonwireless.com/smartphones/apple-iphone-6s-plus",
        "desc": "iPhone&reg; 6s Plus"
      },
      {
        "rate": "5.0",
        "reviewCount": "5560",
        "img_url": "http://s7.vzw.com/is/image/VerizonWireless/iphone6s-spgry-front",
        "price": "27.08",
        "name": "iPhone&reg; 6s",
        "isEdgePrice": "true",
        "img_alt": "iPhone&reg; 6s",
        "isTwoYearPriceRestriction": "true",
        "url": "http://www.verizonwireless.com/smartphones/apple-iphone-6s",
        "desc": "iPhone&reg; 6s"
      }
    ]
  },
  "typeAheadSummary": {
    "autoSelectTerm": "apple*",
    "TypeAheadSuggestedTerms": [
      {
        "name": "Apple",
        "href": "/search/vzwSearch?Ntt=Apple&lid=sayt&sayt=TypeAheadSuggestedTerms"
      },
      {
        "name": "Apple iPhone 6",
        "href": "/search/vzwSearch?Ntt=Apple iPhone 6&lid=sayt&sayt=TypeAheadSuggestedTerms"
      },
      {
        "name": "iOS",
        "href": "/search/vzwSearch?Ntt=iOS&lid=sayt&sayt=TypeAheadSuggestedTerms"
      },
      {
        "name": "iPhone SE",
        "href": "/search/vzwSearch?Ntt=iPhone SE&lid=sayt&sayt=TypeAheadSuggestedTerms"
      },
      {
        "name": "Apple iPhone",
        "href": "/search/vzwSearch?Ntt=Apple iPhone&lid=sayt&sayt=TypeAheadSuggestedTerms"
      }
    ]
  }
};*/
